





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import { CompanyDocument } from '../store/models';
import * as api from '@/store/api';

import DocumentSharing from '@/components/DocumentSharing.vue';
@Component({
    components: {DocumentSharing},
})
export default class MetaYearReview extends CompanyMixin {
    @Prop() readonly doc!: CompanyDocument;

    get commentType() {
        if (this.doc.Data.CommentType === 'auto') {
            return 'Automatisk';
        } else if (this.doc.Data.CommentType === 'custom') {
            return 'Egen';
        }
        return 'Ingen';
    }
}
